// extracted by mini-css-extract-plugin
export default {"addParticipant":"beee05e54f959cbb"};